import React from 'react';
import { connectToStore } from './Provider';
import Reveal from './Reveal';

const VideoGrid = ({
	header,
	subtitle,
	posts,
	openVideoModal,
}) => (
		<Reveal>
			<div className="video-grid grid-container contained">
				<div className="row">
					<div className="col c12--sm">
						<h4 className="sans--small uppercase fw--700 mb2">{subtitle}</h4>
						<h1 className="domaine--large mb2 mb4--md">
							{header}
						</h1>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<div className="video-grid__posts mb4 mb10--lg">
							{createPostsGrid(posts, openVideoModal)}
						</div>
					</div>
				</div>
			</div>
		</Reveal>
	);

/**
 * Creates the grid of posts.
 *
 * @param {Array<Object>} posts The posts from the cms.
 */
function createPostsGrid(posts, openVideoModal) {
	let grid = [];

	posts.map(post => {
		grid.push(
			<div className='pr mb8 mb0--lg'>
				<button
					title='Play'
					onClick={() => openVideoModal(post.videoId)}
					className='full-width pr video__poster bg--black'
					name='play'>
					<div className='image size--1x1 reveal__fade'>
						<picture>
							<source
								srcSet={`${post.postImage.url}?w=1000&auto=format&q=75`}
								media='(min-width: 600px)'
								/>
							<img
								className='full-width'
								alt={post.postImage.alt}
								src={`${post.postImage.url}?w=600&auto=format&q=75`}
							/>
						</picture>
					</div>
					<span className='db video__poster__play' />
					<img
						className='db video__poster__icon'
						alt='play'
						src='/images/icon-play.svg'
					/>
				</button>
				<div className='mt1'>
					<span className='db sans--small tc fw--600 mb1 mt1'>
						{post.videoLength} minutes <span>&#183;</span> {formatDate(post.date)}
					</span>
					<h4 className='domaine--medium tc'>{post.cta}</h4>
				</div>
			</div>,
		);
	});

	return grid;
}

/**
 * Formats the datetime from sanity to the format we want
 *
 * @param {string} date The date passed from sanity.
 */
function formatDate(date) {
	const dateObj = new Date(date);

	return ('0' + (dateObj.getMonth() + 1)).slice(-2) + '.'
		+ ('0' + (dateObj.getDate() + 1)).slice(-2) + '.'
		+ dateObj.getFullYear();
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(VideoGrid);